export const socialLinksData = [
  {
    link: "",
    Icon: "fa-facebook",
  },
  {
    link: "",
    Icon: "fa-linkedin",
  },
  {
    link: "",
    Icon: "fa-instagram",
  },
  {
    link: "",
    Icon: "fa-dribbble",
  },
];

export const servicesCardData = [
  {
    title: "Logo & Brand Identity",
    // desc: "At Limino, we believe a brand identity is a collective experience of how your brand visually and aesthetically looks, feels, and communicates with people. Sometimes that even includes how it sounds, tastes, feels, and even smells.",
    Icon: "fa-crop",
  },
  {
    title: "Marketing & Sales Collateral",
    // desc: "Marketing & Sales Collateral Design from Limino Agency will provide your marketing campaigns with beautiful, clearly designed materials that your audience will want to read, and ensures they remember your name.",
    Icon: "fa-credit-card-alt",
  },
  {
    title: "Brand Makeover & Rebranding",
    // desc: "Rebrand your business with a fresher look! A brand refresh is a makeover for your company Think of it like a personal makeover ... a better haircut, up-to-date outfit, and new shoes that transform how a person is perceived. It's the same with your brand.",
    Icon: "fa-repeat",
  },
  {
    title: "Print Item",
    // desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis possimus sint, modi vitae pariatur excepturi iusto assumenda amet itaque cupiditate soluta quasi dignissimos sapiente repellat, sit dolore maxime debitis quisquam?",
    Icon: "fa-print",
  },
];

export const skillsData = [
  {
    title: "Photoshop",
    value: 85,
  },
  {
    title: "Illustrator",
    value: 95,
  },
  {
    title: "Adobe XD",
    value: 80,
  },
  {
    title: "Adobe Indesign",
    value: 90,
  },
];

export const pricingCardsData = [
  {
    title: "Basic",
    price: 25,
    services: [
      "3 Initial Concepts Included",
      "2 Revisions",
      "Source file",
      "High Resolution",
      "3D Mockup",
      "Vector File",
      "0 Print Item",
    ],
    recommended: false,
  },
  {
    title: "Standard",
    price: 75,
    services: [
      "5 Initial Concepts Included",
      "3 Revisions",
      "Source file",
      "High Resolution",
      "3D Mockup",
      "Vector File",
      "1 Print Item",
    ],
    recommended: true,
  },
  {
    title: "Pro",
    price: 125,
    services: [
      "6 Initial Concepts Included",
      "5 Revisions",
      "Source file",
      "High Resolution",
      "3D Mockup",
      "Vector File",
      "2 Print Item",
    ],
    recommended: false,
  },
];

export const totalWorksData = [
  {
    title: "Clients",
    Icon: "fa-users",
    amount: 17,
  },
  {
    title: "Projects",
    Icon: "fa-codepen",
    amount: 91,
  },
  {
    title: "Awards",
    Icon: "fa-diamond fa-fw",
    amount: 7,
  },
  {
    title: "Experience",
    Icon: "fa-github",
    amount: 5,
  },
];

export const reviewsData = [
  {
    reviewBody:
      "SK's communication level is super. He was no short of amazign! I am so appreciative of his working with me through multiple revisions until we came upon the right design! His patience was incredible and his work - even more so. I would completely recommend siamkh.",
    rating: 5,
    userImg: "https://themebing.com/wp/amike/wp-content/uploads/2019/12/2.jpg",

    username: "Clara Hudson",
    userProfession: "COO, The CYLYX ltd",
  },
  {
    reviewBody:
      "Siam built upon our existing assets and help curate a brand identity around them. He took feedback well, and pushed back as necessary to ensure we saw his vision, which made sure our vision was realised",
    rating: 5,
    userImg: "https://themebing.com/wp/amike/wp-content/uploads/2019/12/2.jpg",

    username: "Tomokoyo",
    userProfession: "CEO, Sigma",
  },
  {
    reviewBody:
      "He is really nice designer. His experiance, design sense, idea generate power is extraordinary",
    rating: 5,
    userImg: "https://themebing.com/wp/amike/wp-content/uploads/2019/12/1.jpg",
    username: "FT Talukder",
    userProfession: "Founder of Techpath",
  },
];

export const blogData = [
  {
    title: "Ten Secrets You Will Not Want To Know",
    poster: "admin",
    date: "Tuesday",
    comments: 3,
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2019/10/blog-2.jpg",
  },
  {
    title: "You’ve gotta dance like there’s nobody watching",
    poster: "admin",
    date: "Wednesday",
    comments: 7,
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2019/06/blog-1.jpg",
  },
  {
    title: "I must explain to you how all this mistaken idea",
    poster: "admin",
    date: "Saturday",
    comments: 5,
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2019/05/blog.jpg",
  },
];

export const apikey = "7F52992E53350B9C89CB2B14E11560E8B843";

export const portfolioCardData = [
  {
    tag: ["Art Direction", "art_direction"],
    title: "Rock",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2018/10/jeremy-perkins-UgNjyPkphtU-unsplash.jpg",
  },
  {
    tag: ["Branding", "branding"],
    title: "In Time",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2019/11/florian-klauer-mk7D-4UCfmg-unsplash.jpg",
  },
  {
    tag: ["Design", "design"],
    title: "Mockup",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2018/10/oliver-pecker-HONJP8DyiSM-unsplash.jpg",
  },
  {
    tag: ["Web", "web"],
    title: "Treasure",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2018/10/colin-carter-w1g2o4J_4Dg-unsplash.jpg",
  },
  {
    tag: ["Art Direction", "art_direction"],
    title: "Daily Note",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2018/10/mukul-wadhwa-xpo5BggQo3E-unsplash.jpg",
  },
  {
    tag: ["Branding", "branding"],
    title: "Handcraft",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2018/10/nagy-arnold-X_IvVDuHvDQ-unsplash.jpg",
  },
  {
    tag: ["Design", "design"],
    title: "Pencil",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2019/11/kui-ye-chen-NuOGFo4PudE-unsplash.jpg",
  },
  {
    tag: ["Web", "web"],
    title: "Focus",
    imgSrc:
      "https://themebing.com/wp/amike/wp-content/uploads/2019/11/julian-o-hayon-HY3l4IeOc3E-unsplash.jpg",
  },
];
